import React from 'react';

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

/**
 * Loading spinner component for loading states
 */
export function Loading({ fullScreen = false, text }: LoadingProps) {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'fixed inset-0 z-50 bg-white/80 dark:bg-gray-900/80' : 'h-full w-full'}`}>
      <div className="flex flex-col items-center gap-2">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-transparent"></div>
        {text && <p className="text-sm text-gray-500 dark:text-gray-400">{text}</p>}
      </div>
    </div>
  );
} 
